<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Links Úteis';    
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>    
<div class="container">
	<p>Confira a lista de links úteis selecionados pela nossa equipe.</p>
	<hr>
	<div class="box-itens-icon grid grid-size--1 grid-size-sm--1">

		<div class="item">			
			<div class="infos">
				<p>
					<i class="fas fa-external-link-square"></i> <a target="_blank" href="http://www.planalto.gov.br/ccivil_03/leis/2002/l10406compilada.htm">http://www.planalto.gov.br/ccivil_03/leis/2002/l10406compilada.htm</a>
				</p>
			</div>
		</div>

		<div class="item">			
			<div class="infos">
				<p>
					<i class="fas fa-external-link-square"></i> <a target="_blank" href="http://www.planalto.gov.br/ccivil_03/leis/l4591.htm">http://www.planalto.gov.br/ccivil_03/leis/l4591.htm</a>
				</p>
			</div>
		</div>

	</div>
	<br />

	<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>

</div>